class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetails = this.querySelector('details');
    if (!this.mainDetails) return;
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.mainDetails.addEventListener('toggle', this.onToggle.bind(this));
  }

  onToggle() {
    if (this.mainDetails.open) document.body.addEventListener('click', this.onBodyClick);
    else document.body.removeEventListener('click', this.onBodyClick);
  }

  handleBodyClick(event) {
    if (!this.contains(event.target)) this.close();
  }

  close() {
    this.mainDetails.removeAttribute('open');
  }
}
customElements.define('details-disclosure', DetailsDisclosure);
